//export const baseURL = "http://localhost/_API_2_";
export const baseURL = "https://tagsistemasdigitais.com.br/_API_2_";
